import {
    CONTACT_STATUS_OPTIONS,
} from "../../../constants/admin/contact/contactConstants";

const ContactFilters = ({
    filters,
    onChange,
    onSubmit,
}) => {
    return (
        <form
            onSubmit={onSubmit}
            className="mb-4 flex flex-wrap gap-4"
        >
            <input
                name="keyword"
                value={filters.keyword}
                onChange={onChange}
                placeholder="Tìm kiếm..."
                className="border p-2 rounded"
            />

            <select
                name="status"
                value={filters.status}
                onChange={onChange}
                className="border p-2 rounded"
            >
                <option value="">
                    Tất cả trạng thái
                </option>

                {CONTACT_STATUS_OPTIONS.map(
                    (option) => (
                        <option
                            key={option.value}
                            value={option.value}
                        >
                            {option.label}
                        </option>
                    )
                )}
            </select>

            <input
                type="date"
                name="startDate"
                value={filters.startDate}
                onChange={onChange}
            />

            <input
                type="date"
                name="endDate"
                value={filters.endDate}
                onChange={onChange}
            />

            <button
                type="submit"
                className="bg-blue-500 text-white px-4 py-2 rounded"
            >
                Lọc
            </button>
        </form>
    );
};

export default ContactFilters;